import PropTypes from 'prop-types';
import { classNames } from '@repo/ui/src/utils/classNames';

const FormHelpText = ({ display, content, unique }) => {
  return (
    <div className={classNames('tw-p-6', display ? 'tw-block' : 'tw-hidden')} id={`${unique}-help`}>
      {content && Array.isArray(content.split('\n')) ? (
        content.split('\n').map((cont, idx) => (
          <p
            id={`${unique}-help-${idx}`}
            key={`${unique}-help-${idx}`}
            className="tw-m-0 tra-text-web-body-s"
            variant="body1"
          >
            {cont}
          </p>
        ))
      ) : typeof content === 'string' ? (
        <p
          id={`${unique}-help-text`}
          key={`${unique}-help-text`}
          className="tra-text-web-body-s tw-mt-6"
          variant="body1"
          component="p"
        >
          {content}
        </p>
      ) : null}
    </div>
  );
};

FormHelpText.propTypes = {
  display: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  unique: PropTypes.string.isRequired,
};

export default FormHelpText;
